(function ($) {
    function get_lang() {
        if ($("body").hasClass("english")) {
            return "en";
        } else {
            return "cs";
        }
    }

    //on load call
    $(window).load(function () {
        $(document).foundation();
    });

    //detect if body has scrolled class and add it if not
    function addBodyClass() {
        if (!$("body").hasClass("scrolled")) {
            $("body").addClass("scrolled");
        }
    }

    //remove body class
    function removeBodyClass() {
        if ($("body").hasClass("scrolled")) {
            $("body").removeClass("scrolled");
        }
    }

    //show or hide the top menu
    $(window).on("scroll load", function () {
        if ($(window).scrollTop() >= 150) {
            addBodyClass();

            //reverse it back
        } else if ($(window).scrollTop() < 150) {
            removeBodyClass();
        }
    });

    //sidebar menu functionality
    jQuery(document).ready(function () {
        $(".start-hide").hide();
        $(".start-hide .optional").hide();
        $(".start-hide .optional").parent().append('<span class="required">*</span>');

        $(".click-box .input-checkbox").click(function () {
            $(".start-hide").slideToggle(400, function() {
                if ($(".start-hide").is(":visible")) {
                    $(".start-hide input").prop("required", true);
                    $(".start-hide").addClass("validate-required");
                } else {
                    $(".start-hide input").prop("required", false);
                    $(".start-hide").removeClass("validate-required");
                }
            });
        });

        if ($(".wp-block-gallery").length > 0) {
            $("img", $(".wp-block-gallery")).each(function () {
                var src = $(this).attr("data-lazyimg");
                var caption = $(this).next("figcaption").text();

                if (src !== undefined && src !== "") {
                    $(this).closest(".wp-block-image").attr("data-src", src);
                }
                if (caption !== undefined && caption !== "") {
                    $(this)
                        .closest(".wp-block-image")
                        .attr("data-sub-html", caption);
                }
            });

            //fire up gallery
            $(".wp-block-gallery").lightGallery({
                selector: ".wp-block-image",
            });

            $(".wp-block-gallery").on(
                "onCloseAfter.lg",
                function (event, prevIndex, index) {
                    $(document).foundation();
                }
            );
        }

        if ($(".wp-block-gallery").length > 0) {
            $(".wp-block-gallery .wp-block-image img").each(function () {
                var src = $(this).attr("src");
                var caption = $(this).closest(".wp-block-image").next("figcaption").text();

                if (src !== undefined && src !== "") {
                    $(this).closest(".wp-block-image").attr("data-src", src);
                }
                if (caption !== undefined && caption !== "") {
                    $(this).closest(".wp-block-image").attr("data-sub-html", caption);
                }
            });

            // Spuštění galerie
            $(".wp-block-gallery").lightGallery({
                selector: ".wp-block-image[data-src]"
            });

            $(".wp-block-gallery").on("onCloseAfter.lg", function () {
                $(document).foundation();
            });
        }

        //mobile menu functionality
        $(window).on("load", function () {
            $("#mobile-menu .menu-item-has-children").append('<i class="arrow-icon"></i>');
        });

        $(document).on(
            "click touchend",
            "#mobile-menu > .menu-item-has-children > i",
            function (e) {
                if (
                    $("#mobile-menu > .menu-item-has-children").hasClass(
                        "showing-ul"
                    )
                ) {
                    //exclude this element
                    var myParent = $(this).closest(
                        "#mobile-menu > .menu-item-has-children"
                    );
                    $("#mobile-menu > .menu-item-has-children")
                        .not(myParent)
                        .removeClass("showing-ul")
                        .children(".sub-menu")
                        .slideUp();
                }

                //show signling
                if ($(this).parent().hasClass("showing-ul")) {
                    $(this).siblings(".sub-menu").slideUp();
                    $(this).parent().removeClass("showing-ul");
                } else {
                    $(this).siblings(".sub-menu").slideDown();
                    $(this).parent().addClass("showing-ul");
                }

                e.preventDefault();
            }
        );

        if (jQuery("#slick-partners").length > 0) {
            jQuery("#slick-partners").slick({
                arrows: true,
                dots: false,
                slidesToShow: 5,
                prevArrow: '<span class="slick-prev slick-arrow"></span>',
                nextArrow: '<span class="slick-next slick-arrow"></span>',
                autoplay: true,
                autoplaySpeed: 3000,
                infinite: true,
                responsive: [
                    {
                        breakpoint: 780,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                        },
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        },
                    },
                ],
            });
        }

        if (jQuery(".top-slider").length > 0) {
            jQuery(".top-slider").slick({
                arrows: false,
                dots: true,
                slidesToShow: 1,
                speed: 1000,
                autoplay: true,
                autoplaySpeed: 5000,
                infinite: true,
                fade: true,
                cssEase: "ease-in-out",
                touchThreshold: 100,
            });
        }
        if (jQuery(".fullwidth-slider").length > 0) {
            jQuery(".fullwidth-slider").slick({
                arrows: false,
                dots: false,
                slidesToShow: 1,
                speed: 1000,
                autoplay: true,
                autoplaySpeed: 5000,
                infinite: true,
                fade: true,
                cssEase: "ease-in-out",
                touchThreshold: 100,
            });
        }

        if (jQuery(".blog-slider").length > 0) {
            jQuery(".blog-slider").slick({
                arrows: false,
                dots: true,
                slidesToShow: 1,
                speed: 1000,
                autoplay: true,
                autoplaySpeed: 5000,
                infinite: true,
                fade: true,
                cssEase: "ease-in-out",
                touchThreshold: 100,
            });
        }

        if (jQuery(".journal_slider").length > 0) {
            jQuery(".journal_slider").slick({
                infinite: true,
                fade: false,
                dots: false,
                arrows: true,
                cssEase: "ease-in-out",
                touchThreshold: 100,
                variableWidth: true,
                slidesToShow: 1,
                /*responsive: [
                    {
                        breakpoint: 950,
                        settings: {
                          slidesToShow: 4,
                          slidesToScroll: 3,
                        }
                      },
                    {
                      breakpoint: 780,
                      settings: {
                        slidesToShow: 3,
                        slidesToScroll: 2,
                      }
                    },
                    {
                      breakpoint: 480,
                      settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                      }
                    }
                ]*/
            });
        }

        if (jQuery(".fullwidth-slider").length > 0) {
            jQuery(".fullwidth-slider").slick({
                arrows: true,
                dots: false,
                slidesToShow: 1,
                speed: 1000,
                autoplay: true,
                autoplaySpeed: 5000,
                infinite: true,
                fade: true,
                cssEase: "ease-in-out",
                touchThreshold: 100,
                prevArrow: '<div class="grid-container"><span class="slick-prev slick-arrow">Předchozí</span> </div>',
                nextArrow: '<div class="grid-container"><span class="slick-next slick-arrow">Následující</span></div>',
            });
        }


        if (jQuery("#category-filter").length > 0) {
            jQuery("#category-filter").slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                autoplay: false,
                autoplaySpeed: 2000,
                arrows: true,
                dots: false,
                infinite: true,
                prevArrow: '<span class="slick-prev slick-arrow"></span>',
                nextArrow: '<span class="slick-next slick-arrow"></span>',
                responsive: [
                    {
                        breakpoint: 950,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 780,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        }
                    }
                ]
            });
        }

        if (jQuery("#room-calendar").length > 0) {
            jQuery("#room-calendar").slick({
                arrows: true,
                dots: false,
                slidesToShow: 1,
                prevArrow: '<span class="slick-prev slick-arrow"></span>',
                nextArrow: '<span class="slick-next slick-arrow"></span>',
                autoplaySpeed: false,
                infinite: false,
                fade: true,
                cssEase: "ease-in-out",
                touchThreshold: 100,
            });
        }

        //lightgallerie
        //block gallery
        if ($(".wp-block-gallery").length > 0) {
            //add gallery items src
            $("img", $(".wp-block-gallery")).each(function () {
                var src = $(this).attr("data-lazyimg");
                var caption = $(this).next("figcaption").text();

                if (src !== undefined && src !== "") {
                    $(this).closest("a").attr("data-src", src);
                }
                if (caption !== undefined && caption !== "") {
                    $(this).closest("a").attr("data-sub-html", caption);
                }
            });

            //fire up gallery
            $(".wp-block-gallery").lightGallery({
                selector: ".wp-block-gallery a",
                preload: 1,
                cssEasing: "cubic-bezier(0.25, 0, 0.25, 1)",
            });
        }

        //galerie obrázků
        jQuery("#gallery").lightGallery({
            preload: 1,
            cssEasing: "cubic-bezier(0.25, 0, 0.25, 1)",
            speed: 1000,
            showThumbByDefault: false,
            selector: "#gallery figure",
            counter: false,
            thumbContHeight: 90,
        });
    });

    $(window).on("load", function () {
        if (
            $(".woo-popup-message").length > 0 &&
            !$("body").hasClass("woocommerce-checkout") &&
            !$("body").hasClass("woocommerce-cart")
        ) {
            setTimeout(function () {
                $(".woo-popup-message").slideUp();
            }, 7500);
        }

        //načítací animace
        setTimeout(function () {
            $(".green-half").addClass("green-half-loaded");
        }, 500);
    });

    //show search bar
    $(".search-toggle, #close-admin-toggle").on("click", function (e) {
        var searchbar = $("#search-bar");

        if (searchbar.hasClass("bar-active")) {
            searchbar.removeClass("bar-active");
        } else {
            searchbar.addClass("bar-active");
        }
    });

    //double click on top menu functionality
    /**
     * jquery-doubleTapToGo plugin
     * Copyright 2017 DACHCOM.DIGITAL AG
     * @author Marco Rieser
     * @author Volker Andres
     * @author Stefan Hagspiel
     * @version 3.0.2
     * @see https://github.com/dachcom-digital/jquery-doubletaptogo
     */

    (function ($, window, document, undefined) {
        "use strict";

        var pluginName = "doubleTapToGo",
            defaults = {
                automatic: true,
                selectorClass: "doubletap",
                selectorChain: "li:has(ul)",
            };

        function DoubleTapToGo(element, options) {
            this.element = element;

            this.settings = $.extend({}, defaults, options);

            this._defaults = defaults;

            this._name = pluginName;

            this.init();
        }

        $.extend(DoubleTapToGo.prototype, {
            preventClick: false,

            currentTap: $(),

            init: function () {
                $(this.element)
                    .on(
                        "touchstart",
                        "." + this.settings.selectorClass,
                        this._tap.bind(this)
                    )

                    .on(
                        "click",
                        "." + this.settings.selectorClass,
                        this._click.bind(this)
                    )

                    .on("remove", this._destroy.bind(this));

                this._addSelectors();
            },

            _addSelectors: function () {
                if (this.settings.automatic !== true) {
                    return;
                }

                $(this.element)
                    .find(this.settings.selectorChain)

                    .addClass(this.settings.selectorClass);
            },

            _click: function (event) {
                if (this.preventClick) {
                    event.preventDefault();
                } else {
                    this.currentTap = $();
                }
            },

            _tap: function (event) {
                var $target = $(event.target).closest("li");

                if (!$target.hasClass(this.settings.selectorClass)) {
                    this.preventClick = false;

                    return;
                }

                if ($target.get(0) === this.currentTap.get(0)) {
                    this.preventClick = false;

                    return;
                }

                this.preventClick = true;

                this.currentTap = $target;

                event.stopPropagation();
            },

            _destroy: function () {
                $(this.element).off();
            },

            reset: function () {
                this.currentTap = $();
            },
        });

        $.fn[pluginName] = function (options) {
            var args = arguments,
                returns;

            if (options === undefined || typeof options === "object") {
                return this.each(function () {
                    if (!$.data(this, pluginName)) {
                        $.data(
                            this,
                            pluginName,
                            new DoubleTapToGo(this, options)
                        );
                    }
                });
            } else if (
                typeof options === "string" &&
                options[0] !== "_" &&
                options !== "init"
            ) {
                this.each(function () {
                    var instance = $.data(this, pluginName),
                        methodName =
                            options === "destroy" ? "_destroy" : options;

                    if (
                        instance instanceof DoubleTapToGo &&
                        typeof instance[methodName] === "function"
                    ) {
                        returns = instance[methodName].apply(
                            instance,
                            Array.prototype.slice.call(args, 1)
                        );
                    }

                    if (options === "destroy") {
                        $.data(this, pluginName, null);
                    }
                });

                return returns !== undefined ? returns : this;
            }
        };
    })(jQuery, window, document);

    $(function () {
        $(".header-menu").doubleTapToGo();
    });

    function get_browser() {
        var ua = navigator.userAgent,
            tem,
            M =
                ua.match(
                    /(opera|yabrowser|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
                ) || [];
        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            return { name: "IE", version: tem[1] || "" };
        }

        if (M[1] === "Chrome") {
            tem = ua.match(/\bOPR|Edge\/(\d+)/);

            if (tem != null) {
                return { name: "Opera", version: tem[1] };
            }
        }

        M = M[2]
            ? [M[1], M[2]]
            : [navigator.appName, navigator.appVersion, "-?"];

        if ((tem = ua.match(/version\/(\d+)/i)) != null) {
            M.splice(1, 1, tem[1]);
        }

        return {
            name: M[0],

            version: M[1],
        };
    }

    function iOSversion() {
        if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
            if (!!window.indexedDB) {
                return 8;
            }

            if (!!window.SpeechSynthesisUtterance) {
                return 7;
            }

            if (!!window.webkitAudioContext) {
                return 6;
            }

            if (!!window.matchMedia) {
                return 5;
            }

            if (!!window.history && "pushState" in window.history) {
                return 4;
            }

            return 3;
        }
        return "";
    }

    //add css script with js
    function append_no_flexbox() {
        document.querySelector("head").innerHTML +=
            '<link rel="stylesheet" href="' +
            globaldata.theme_url +
            '/assets/styles/css-specific/noflexbox.css" type="text/css"/>';
    }

    $(document).ready(function () {
        //alert( get_browser().name + " " + get_browser().version );
        //select chrome under version 28
        if (
            get_browser().name == "Chrome" &&
            parseInt(get_browser().version) <= 28
        ) {
            jQuery("html")
                .addClass("no-sliding")
                .addClass("old-chrome")
                .addClass("no-flexbox");
            //append no flexbox css
            append_no_flexbox();
        }

        // Select Firefox under 28
        if (
            get_browser().name == "Firefox" &&
            parseInt(get_browser().version) <= 28
        ) {
            jQuery("html")
                .addClass("no-sliding")
                .addClass("old-firefox")
                .addClass("no-flexbox");
            //append no flexbox css
            append_no_flexbox();
        }

        // Select Safari under version 8
        if (
            get_browser().name == "Safari" &&
            parseInt(get_browser().version) <= 8
        ) {
            jQuery("html")
                .addClass("no-sliding")
                .addClass("old-safari")
                .addClass("no-flexbox");
            //append no flexbox css
            append_no_flexbox();
        }

        // Select IE under 10
        if (
            get_browser().name == "Msie" &&
            parseInt(get_browser().version) <= 10
        ) {
            jQuery("html")
                .addClass("no-sliding")
                .addClass("old-ie")
                .addClass("no-flexbox");
            //append no flexbox css
            append_no_flexbox();
        }

        //detect old IOS
        if (iOSversion() === 4 || iOSversion() === 3) {
            jQuery("html")
                .addClass("no-sliding")
                .addClass("old-iphone")
                .addClass("no-flexbox");
            //append no flexbox css
            append_no_flexbox();
        }
    });

    /**
     * initMap
     *
     * Renders a Google Map onto the selected jQuery element
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   jQuery $el The jQuery element.
     * @return  object The map instance.
     */
    function initMap($el) {
        // Find marker elements within map.
        var $markers = $el.find(".marker");

        // Create gerenic map.
        var mapArgs = {
            zoom: $el.data("zoom") || 16,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
        };
        var map = new google.maps.Map($el[0], mapArgs);

        // Add markers.
        map.markers = [];
        $markers.each(function () {
            initMarker($(this), map);
        });

        // Center map based on markers.
        centerMap(map);

        // Return map instance.
        return map;
    }

    /**
     * initMarker
     *
     * Creates a marker for the given jQuery element and map.
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   jQuery $el The jQuery element.
     * @param   object The map instance.
     * @return  object The marker instance.
     */
    function initMarker($marker, map) {
        // Get position from marker.
        var lat = $marker.data("lat");
        var lng = $marker.data("lng");
        var latLng = {
            lat: parseFloat(lat),
            lng: parseFloat(lng),
        };

        // Create marker instance.
        var marker = new google.maps.Marker({
            position: latLng,
            map: map,
        });

        // Append to reference for later use.
        map.markers.push(marker);

        // If marker contains HTML, add it to an infoWindow.
        if ($marker.html()) {
            // Create info window.
            var infowindow = new google.maps.InfoWindow({
                content: $marker.html(),
            });

            // Show info window when marker is clicked.
            google.maps.event.addListener(marker, "click", function () {
                infowindow.open(map, marker);
            });
        }
    }

    /**
     * centerMap
     *
     * Centers the map showing all markers in view.
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   object The map instance.
     * @return  void
     */
    function centerMap(map) {
        // Create map boundaries from all map markers.
        var bounds = new google.maps.LatLngBounds();
        map.markers.forEach(function (marker) {
            bounds.extend({
                lat: marker.position.lat(),
                lng: marker.position.lng(),
            });
        });

        // Case: Single marker.
        if (map.markers.length == 1) {
            map.setCenter(bounds.getCenter());

            // Case: Multiple markers.
        } else {
            map.fitBounds(bounds);
        }
    }

    // Render maps on page load.
    $(document).ready(function () {
        $(".acf-map").each(function () {
            var map = initMap($(this));
        });
    });

    /* Slide out menu
    ====================================================================*/

    //include slideout menu
    !(function (t) {
        if ("object" == typeof exports && "undefined" != typeof module)
            module.exports = t();
        else if ("function" == typeof define && define.amd) define([], t);
        else {
            var e;
            "undefined" != typeof window
                ? (e = window)
                : "undefined" != typeof global
                    ? (e = global)
                    : "undefined" != typeof self && (e = self),
                (e.Slideout = t());
        }
    })(function () {
        var t, e, n;
        return (function i(t, e, n) {
            function o(r, a) {
                if (!e[r]) {
                    if (!t[r]) {
                        var u = typeof require == "function" && require;
                        if (!a && u) return u(r, !0);
                        if (s) return s(r, !0);
                        var l = new Error("Cannot find module '" + r + "'");
                        throw ((l.code = "MODULE_NOT_FOUND"), l);
                    }
                    var f = (e[r] = { exports: {} });
                    t[r][0].call(
                        f.exports,
                        function (e) {
                            var n = t[r][1][e];
                            return o(n ? n : e);
                        },
                        f,
                        f.exports,
                        i,
                        t,
                        e,
                        n
                    );
                }
                return e[r].exports;
            }
            var s = typeof require == "function" && require;
            for (var r = 0; r < n.length; r++) o(n[r]);
            return o;
        })(
            {
                1: [
                    function (t, e, n) {
                        "use strict";
                        var i = t("decouple");
                        var o = t("emitter");
                        var s;
                        var r = false;
                        var a = window.document;
                        var u = a.documentElement;
                        var l = window.navigator.msPointerEnabled;
                        var f = {
                            start: l ? "MSPointerDown" : "touchstart",
                            move: l ? "MSPointerMove" : "touchmove",
                            end: l ? "MSPointerUp" : "touchend",
                        };
                        var h = (function v() {
                            var t = /^(Webkit|Khtml|Moz|ms|O)(?=[A-Z])/;
                            var e = a.getElementsByTagName("script")[0].style;
                            for (var n in e) {
                                if (t.test(n)) {
                                    return (
                                        "-" + n.match(t)[0].toLowerCase() + "-"
                                    );
                                }
                            }
                            if ("WebkitOpacity" in e) {
                                return "-webkit-";
                            }
                            if ("KhtmlOpacity" in e) {
                                return "-khtml-";
                            }
                            return "";
                        })();
                        function c(t, e) {
                            for (var n in e) {
                                if (e[n]) {
                                    t[n] = e[n];
                                }
                            }
                            return t;
                        }
                        function p(t, e) {
                            t.prototype = c(t.prototype || {}, e.prototype);
                        }
                        function d(t) {
                            while (t.parentNode) {
                                if (
                                    t.getAttribute("data-slideout-ignore") !==
                                    null
                                ) {
                                    return t;
                                }
                                t = t.parentNode;
                            }
                            return null;
                        }
                        function _(t) {
                            t = t || {};
                            this._startOffsetX = 0;
                            this._currentOffsetX = 0;
                            this._opening = false;
                            this._moved = false;
                            this._opened = false;
                            this._preventOpen = false;
                            this._touch =
                                t.touch === undefined ? true : t.touch && true;
                            this._side = t.side || "left";
                            this.panel = t.panel;
                            this.menu = t.menu;
                            if (
                                !this.panel.classList.contains("slideout-panel")
                            ) {
                                this.panel.classList.add("slideout-panel");
                            }
                            if (
                                !this.panel.classList.contains(
                                    "slideout-panel-" + this._side
                                )
                            ) {
                                this.panel.classList.add(
                                    "slideout-panel-" + this._side
                                );
                            }
                            if (
                                !this.menu.classList.contains("slideout-menu")
                            ) {
                                this.menu.classList.add("slideout-menu");
                            }
                            if (
                                !this.menu.classList.contains(
                                    "slideout-menu-" + this._side
                                )
                            ) {
                                this.menu.classList.add(
                                    "slideout-menu-" + this._side
                                );
                            }
                            this._fx = t.fx || "ease";
                            this._duration = parseInt(t.duration, 10) || 300;
                            this._tolerance = parseInt(t.tolerance, 10) || 70;
                            this._padding = this._translateTo =
                                parseInt(t.padding, 10) || 256;
                            this._orientation = this._side === "right" ? -1 : 1;
                            this._translateTo *= this._orientation;
                            if (this._touch) {
                                this._initTouchEvents();
                            }
                        }
                        p(_, o);
                        _.prototype.open = function () {
                            var t = this;
                            this.emit("beforeopen");
                            if (!u.classList.contains("slideout-open")) {
                                u.classList.add("slideout-open");
                            }
                            this._setTransition();
                            this._translateXTo(this._translateTo);
                            this._opened = true;
                            setTimeout(function () {
                                t.panel.style.transition = t.panel.style[
                                    "-webkit-transition"
                                ] = "";
                                t.emit("open");
                            }, this._duration + 50);
                            return this;
                        };
                        _.prototype.close = function () {
                            var t = this;
                            if (!this.isOpen() && !this._opening) {
                                return this;
                            }
                            this.emit("beforeclose");
                            this._setTransition();
                            this._translateXTo(0);
                            this._opened = false;
                            setTimeout(function () {
                                u.classList.remove("slideout-open");
                                t.panel.style.transition =
                                    t.panel.style["-webkit-transition"] =
                                    t.panel.style[h + "transform"] =
                                    t.panel.style.transform =
                                    "";
                                t.emit("close");
                            }, this._duration + 50);
                            return this;
                        };
                        _.prototype.toggle = function () {
                            return this.isOpen() ? this.close() : this.open();
                        };
                        _.prototype.isOpen = function () {
                            return this._opened;
                        };
                        _.prototype._translateXTo = function (t) {
                            this._currentOffsetX = t;
                            this.panel.style[h + "transform"] =
                                this.panel.style.transform =
                                "translateX(" + t + "px)";
                            return this;
                        };
                        _.prototype._setTransition = function () {
                            this.panel.style[h + "transition"] =
                                this.panel.style.transition =
                                h +
                                "transform " +
                                this._duration +
                                "ms " +
                                this._fx;
                            return this;
                        };
                        _.prototype._initTouchEvents = function () {
                            var t = this;
                            this._onScrollFn = i(a, "scroll", function () {
                                if (!t._moved) {
                                    clearTimeout(s);
                                    r = true;
                                    s = setTimeout(function () {
                                        r = false;
                                    }, 250);
                                }
                            });
                            this._preventMove = function (e) {
                                if (t._moved) {
                                    e.preventDefault();
                                }
                            };
                            a.addEventListener(f.move, this._preventMove);
                            this._resetTouchFn = function (e) {
                                if (typeof e.touches === "undefined") {
                                    return;
                                }
                                t._moved = false;
                                t._opening = false;
                                t._startOffsetX = e.touches[0].pageX;
                                t._preventOpen =
                                    !t._touch ||
                                    (!t.isOpen() && t.menu.clientWidth !== 0);
                            };
                            this.panel.addEventListener(
                                f.start,
                                this._resetTouchFn
                            );
                            this._onTouchCancelFn = function () {
                                t._moved = false;
                                t._opening = false;
                            };
                            this.panel.addEventListener(
                                "touchcancel",
                                this._onTouchCancelFn
                            );
                            this._onTouchEndFn = function () {
                                if (t._moved) {
                                    t.emit("translateend");
                                    t._opening &&
                                        Math.abs(t._currentOffsetX) > t._tolerance
                                        ? t.open()
                                        : t.close();
                                }
                                t._moved = false;
                            };
                            this.panel.addEventListener(
                                f.end,
                                this._onTouchEndFn
                            );
                            this._onTouchMoveFn = function (e) {
                                if (
                                    r ||
                                    t._preventOpen ||
                                    typeof e.touches === "undefined" ||
                                    d(e.target)
                                ) {
                                    return;
                                }
                                var n = e.touches[0].clientX - t._startOffsetX;
                                var i = (t._currentOffsetX = n);
                                if (Math.abs(i) > t._padding) {
                                    return;
                                }
                                if (Math.abs(n) > 20) {
                                    t._opening = true;
                                    var o = n * t._orientation;
                                    if (
                                        (t._opened && o > 0) ||
                                        (!t._opened && o < 0)
                                    ) {
                                        return;
                                    }
                                    if (!t._moved) {
                                        t.emit("translatestart");
                                    }
                                    if (o <= 0) {
                                        i = n + t._padding * t._orientation;
                                        t._opening = false;
                                    }
                                    if (
                                        !(
                                            t._moved &&
                                            u.classList.contains(
                                                "slideout-open"
                                            )
                                        )
                                    ) {
                                        u.classList.add("slideout-open");
                                    }
                                    t.panel.style[h + "transform"] =
                                        t.panel.style.transform =
                                        "translateX(" + i + "px)";
                                    t.emit("translate", i);
                                    t._moved = true;
                                }
                            };
                            this.panel.addEventListener(
                                f.move,
                                this._onTouchMoveFn
                            );
                            return this;
                        };
                        _.prototype.enableTouch = function () {
                            this._touch = true;
                            return this;
                        };
                        _.prototype.disableTouch = function () {
                            this._touch = false;
                            return this;
                        };
                        _.prototype.destroy = function () {
                            this.close();
                            a.removeEventListener(f.move, this._preventMove);
                            this.panel.removeEventListener(
                                f.start,
                                this._resetTouchFn
                            );
                            this.panel.removeEventListener(
                                "touchcancel",
                                this._onTouchCancelFn
                            );
                            this.panel.removeEventListener(
                                f.end,
                                this._onTouchEndFn
                            );
                            this.panel.removeEventListener(
                                f.move,
                                this._onTouchMoveFn
                            );
                            a.removeEventListener("scroll", this._onScrollFn);
                            this.open = this.close = function () { };
                            return this;
                        };
                        e.exports = _;
                    },
                    { decouple: 2, emitter: 3 },
                ],
                2: [
                    function (t, e, n) {
                        "use strict";
                        var i = (function () {
                            return (
                                window.requestAnimationFrame ||
                                window.webkitRequestAnimationFrame ||
                                function (t) {
                                    window.setTimeout(t, 1e3 / 60);
                                }
                            );
                        })();
                        function o(t, e, n) {
                            var o,
                                s = false;
                            function r(t) {
                                o = t;
                                a();
                            }
                            function a() {
                                if (!s) {
                                    i(u);
                                    s = true;
                                }
                            }
                            function u() {
                                n.call(t, o);
                                s = false;
                            }
                            t.addEventListener(e, r, false);
                            return r;
                        }
                        e.exports = o;
                    },
                    {},
                ],
                3: [
                    function (t, e, n) {
                        "use strict";
                        var i = function (t, e) {
                            if (!(t instanceof e)) {
                                throw new TypeError(
                                    "Cannot call a class as a function"
                                );
                            }
                        };
                        n.__esModule = true;
                        var o = (function () {
                            function t() {
                                i(this, t);
                            }
                            t.prototype.on = function e(t, n) {
                                this._eventCollection =
                                    this._eventCollection || {};
                                this._eventCollection[t] =
                                    this._eventCollection[t] || [];
                                this._eventCollection[t].push(n);
                                return this;
                            };
                            t.prototype.once = function n(t, e) {
                                var n = this;
                                function i() {
                                    n.off(t, i);
                                    e.apply(this, arguments);
                                }
                                i.listener = e;
                                this.on(t, i);
                                return this;
                            };
                            t.prototype.off = function o(t, e) {
                                var n = undefined;
                                if (
                                    !this._eventCollection ||
                                    !(n = this._eventCollection[t])
                                ) {
                                    return this;
                                }
                                n.forEach(function (t, i) {
                                    if (t === e || t.listener === e) {
                                        n.splice(i, 1);
                                    }
                                });
                                if (n.length === 0) {
                                    delete this._eventCollection[t];
                                }
                                return this;
                            };
                            t.prototype.emit = function s(t) {
                                var e = this;
                                for (
                                    var n = arguments.length,
                                    i = Array(n > 1 ? n - 1 : 0),
                                    o = 1;
                                    o < n;
                                    o++
                                ) {
                                    i[o - 1] = arguments[o];
                                }
                                var s = undefined;
                                if (
                                    !this._eventCollection ||
                                    !(s = this._eventCollection[t])
                                ) {
                                    return this;
                                }
                                s = s.slice(0);
                                s.forEach(function (t) {
                                    return t.apply(e, i);
                                });
                                return this;
                            };
                            return t;
                        })();
                        n["default"] = o;
                        e.exports = n["default"];
                    },
                    {},
                ],
            },
            {},
            [1]
        )(1);
    });

    var slideout = new Slideout({
        panel: document.getElementById("panel"),
        menu: document.getElementById("menu"),
        padding: 256,
        side: "right",
        tolerance: 70,
    });

    // Toggle button
    document
        .querySelector(".js-slideout-toggle")
        .addEventListener("click", function () {
            slideout.toggle();
        });

    //toggle button 2
    document
        .querySelector(".slideout-menu .close-button")
        .addEventListener("click", function () {
            slideout.toggle();
        });

    $(window).on("resize load", function () {
        if (jQuery(".mobile-sliders").length > 0) {
            var ww = document.body.clientWidth;

            if (ww < 640) {
                if (!jQuery(".mobile-sliders").hasClass("slick-initialized")) {
                    jQuery(".mobile-sliders").slick({
                        arrows: true,
                        dots: false,
                        slidesToShow: 1,
                        speed: 1000,
                        autoplaySpeed: 5000,
                        infinite: true,
                        fade: true,
                        cssEase: "ease-in-out",
                        touchThreshold: 100,
                    });
                }
            } else {
                if (jQuery(".mobile-sliders").hasClass("slick-initialized")) {
                    jQuery(".mobile-sliders").slick("unslick");
                }
            }
        }
    });
    // GDPR cookie banner
    $(document).ready(function () {
        var cookieconsent = initCookieConsent();
        cookieconsent.run({
            current_lang: get_lang(),
            page_scripts: true,
            autorun: true,
            delay: 0,
            autoclear_cookies: true,
            theme_css:
                globaldata.theme_url +
                "/assets/styles/css-specific/cookiebanner.css",
            gui_options: {
                consent_modal: {
                    layout: "box", // box/cloud/bar
                    position: "top center", // bottom/top + left/right/center
                    transition: "slide", // zoom/slide
                },
                settings_modal: {
                    layout: "box", // box/bar
                    transition: "slide", // zoom/slide
                },
            },

            onAccept: function (cookies) {
                if (cookieconsent.allowedCategory("necessary")) {
                    var dataLayer = window.dataLayer || [];
                    dataLayer.push({
                        event: "CookieConsent",
                        consentType: "necessary",
                    });
                }

                if (cookieconsent.allowedCategory("tracking")) {
                    var dataLayer = window.dataLayer || [];
                    dataLayer.push({
                        event: "CookieConsent",
                        consentType: "tracking",
                    });
                }

                if (cookieconsent.allowedCategory("performance")) {
                    var dataLayer = window.dataLayer || [];
                    dataLayer.push({
                        event: "CookieConsent",
                        consentType: "performance",
                    });
                }
            },

            languages: {
                en: {
                    consent_modal: {
                        title: globaldata.title,
                        description: globaldata.consent_description,
                        primary_btn: {
                            text: globaldata.primarybtn_text,
                            role: "accept_all", //'accept_selected' or 'accept_all'
                        },
                        secondary_btn: {
                            text: globaldata.secondarybtn_text,
                            role: "settings", //'settings' or 'accept_necessary'
                        },
                        third_btn: {
                            text: globaldata.thirdbtn_text,
                            role: "accept_necessary", //'accept_necessary'
                        },
                    },
                    settings_modal: {
                        title: globaldata.title,
                        save_settings_btn: globaldata.pref_btn_text,
                        accept_all_btn: globaldata.primarybtn_text,
                        reject_all_btn: globaldata.thirdbtn_text,
                        close_btn_label: globaldata.cookie_close_btn_text,
                        cookie_table_headers: [
                            { col1: globaldata.cookie_table_header1 },
                            { col2: globaldata.cookie_table_header2 },
                        ],
                        blocks: [
                            {
                                title: globaldata.cookiemaintitle,
                                description: globaldata.block_description,
                            },
                            {
                                title: globaldata.func_cookie_title,
                                description: globaldata.func_cookie_desc,
                                toggle: {
                                    value: "necessary",
                                    enabled: true,
                                    readonly: true,
                                },
                                cookie_table: [
                                    {
                                        col1: "cc_cookie",
                                        col2: globaldata.func_cookie_table2,
                                    },
                                ],
                            },
                            {
                                title: globaldata.anal_cookie_title,
                                description: globaldata.anal_cookie_desc,
                                toggle: {
                                    value: "performance",
                                    enabled: true,
                                    readonly: false,
                                },
                                cookie_table: [
                                    {
                                        col1: "_ga/_ga*, _gid",
                                        col2: globaldata.anal_cookie_table_desc1,
                                    },
                                    {
                                        col1: "_gcl_au",
                                        col2: globaldata.anal_cookie_table_desc2,
                                    },
                                ],
                            },
                            {
                                title: globaldata.market_cookie_title,
                                description: globaldata.market_cookie_desc,
                                toggle: {
                                    value: "tracking",
                                    enabled: false,
                                    readonly: false,
                                },
                                cookie_table: [
                                    {
                                        col1: "_fbp",
                                        col2: globaldata.fb_pixel,
                                    },
                                ],
                            },
                        ],
                    },
                },
            },
        });

        if (!cookieconsent.validCookie("cc_cookie")) {
            var dataLayer = window.dataLayer || [];
            dataLayer.push({
                event: "CookieConsent",
                consentType: "empty",
            });
        }
        var el = $('#c-inr-i #c-txt .cc-link').remove();
        el.removeClass('cc-link').addClass('c-bn').attr('id', 'rj-all');
        $('#cm #c-bns').append(el);
        $('#cm #rj-all').on('click', function () {
            $('#s-rall-bn').click();
        });


        $('.digi_side_box_links_block a').on('click', function (e) {
            var href = $(this).attr('href');

            if (href.startsWith('#')) {
                e.preventDefault();

                var offset = 70;
                var target = $(href);

                if (target.length) {
                    $('html, body').animate({
                        scrollTop: target.offset().top - offset
                    }, 300);
                }
            }
        });

        function adjustHeights() {
            var windowWidth = $(window).width();
            var elementsPerRow;

            if (windowWidth > 1024) {
                elementsPerRow = 3;
            } else if (windowWidth > 640) {
                elementsPerRow = 2;
            } else {
                elementsPerRow = 1;
            }

            $('.caka .digi-blogs .grid-x').each(function () {
                var rows = $(this).find('.cell');
                for (var i = 0; i < rows.length; i += elementsPerRow) {
                    var maxHeight = 0;
                    var row = rows.slice(i, i + elementsPerRow);

                    row.find('h3').height('auto');

                    row.each(function () {
                        var h3Height = $(this).find('h3').height();
                        if (h3Height > maxHeight) {
                            maxHeight = h3Height;
                        }
                    });

                    row.find('h3').height(maxHeight);
                }
            });
        }

        $(window).resize(adjustHeights);
        $(document).ready(adjustHeights);


    });


    $(document).ready(function () {
        $('.dropbtn').click(function () {
            $('#myDropdown').toggleClass('show');
        });

        $(window).click(function (event) {
            if (!$(event.target).hasClass('dropbtn')) {
                $('.dropdown-content').each(function () {
                    if ($(this).hasClass('show')) {
                        $(this).removeClass('show');
                    }
                });
            }
        });

        $('.keyword-search').on('keyup input', function(event) {
            console.log($(this).val());
            if ($(this).val().trim() !== '') {
                $('#search-icon').hide();
            } else {
                $('#search-icon').show();
            }
            event.stopPropagation();
        }).trigger('input');
        
    });


})(jQuery);
